import { Button, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Controller, ControllerRenderProps } from "react-hook-form";
import { textFieldStyles, submitButtonStyles, backButtonStyles } from "./theme";
import { useRecoveryPassword } from "@src/entities/login";

import styles from "./style.module.scss";
import { RESEND_TIMEOUT } from "@src/features/accountDeletion/ui/AccountDeletionStep1/constants";

interface ResetPasswordFormProps {
  email: string;
  password: string;
}

interface Props {
  setStep: (step: number) => void;
  setData: (data: any) => void;
  setIsDisabledBtn: (falg: boolean) => void;
  setRemainingSeconds: (value: number) => void;
  remainingSeconds: number;
  isDisabledBtn: boolean;
}

export const ResetPasswordStep1 = ({
  setStep,
  setData,
  setIsDisabledBtn,
  setRemainingSeconds,
  isDisabledBtn,
  remainingSeconds,
}: Props) => {
  const navigate = useNavigate();
  const { mutate: recoveryPassword } = useRecoveryPassword();
  const [searchParams] = useSearchParams();
  const login =
    searchParams.get("login") !== "null" ? searchParams.get("login") ?? "" : "";

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<ResetPasswordFormProps>({
    defaultValues: {
      email: login,
    },
    mode: "onTouched",
  });

  const onSubmit = (data: ResetPasswordFormProps) => {
    recoveryPassword(
      { login: data.email },
      {
        onSuccess: () => {
          setData((prev: any) => ({ ...prev, email: data.email }));
          const unblockTime = Date.now() + RESEND_TIMEOUT;
          localStorage.setItem("blockUntilForReset", unblockTime.toString());
          setIsDisabledBtn(true);
          setRemainingSeconds(RESEND_TIMEOUT / 1000);
          setStep(2);
        },
      }
    );
  };

  const formatTime = (seconds: number) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min} мин. ${sec.toString().padStart(2, "0")} сек.`;
  };

  return (
    <>
      <Typography className={styles.formTitle}>Восстановить пароль</Typography>
      <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <Controller
          name="email"
          control={control}
          rules={{
            required: "Поле обязательно для заполнения",
            pattern: {
              value: /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
              message: "Неверный формат email",
            },
          }}
          render={({
            field,
          }: {
            field: ControllerRenderProps<ResetPasswordFormProps, "email">;
          }) => (
            <TextField
              {...field}
              label="Почта"
              variant="outlined"
              fullWidth
              error={!!errors.email}
              helperText={
                isDisabledBtn
                  ? `Повторная отправка кода подтверждения будет доступна через ${formatTime(
                      remainingSeconds
                    )}`
                  : errors.email?.message
              }
              className={styles.input}
              InputProps={{
                style: {
                  borderRadius: 24,
                  color: "#fff",
                },
              }}
              InputLabelProps={{
                style: { color: "#ffffff83" },
              }}
              sx={textFieldStyles}
            />
          )}
        />
        <Button
          disabled={isDisabledBtn || !isValid}
          type="submit"
          variant="contained"
          className={styles.button}
          sx={submitButtonStyles}
        >
          Отправить код подтверждения
        </Button>
      </form>
      <Button
        variant="text"
        sx={backButtonStyles}
        onClick={() => navigate("/autorization")}
      >
        Вернуться
      </Button>
    </>
  );
};
